export enum Roles {
	TEAMMEMBER = 'store-team-member',
	ADMIN = 'store-admin-member',
}
